export default {
  name: 'myCreate',
  data() {
    return {
      loading: false,

      dialogTip: {
        show: false,
        content: '',
      },

      formData: {
        check_type: 2, // 进入验证方式：1=验证码；2=免费
        check_code: '', // 进入直播间验证码
        is_lesson_preparation: 0, // 是否设置为备课直播间:0=否;1=是
        is_playback: 1, // 是否录制回放:0=否;1=是

        type: 3,
        video_type: 2,
        start_time: (new Date(Date.now() + 288e5)).toISOString().replace('T', ' ').split('.')[0],
      },
      formKeti: 0,
      formTeacher: {},
      formClasses: [],

      classData: '',
      hideType: '',

      id: this.$route.query.id,
      name: this.$route.query.name,
      title: this.$route.query.title,
      hide_course_type: this.$route.query.hide_course_type,

      code: this.$route.query.code,
      course_type: this.$route.query.course_type,
      user: {},
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.$nextTick(() => {
      const _formData = localStorage.getItem('my_class_formdata');

      if (this.classesBack && _formData) {
        const _formClasses = localStorage.getItem('my_class_formclasses');

        this.formData = JSON.parse(_formData);

        _formClasses && (this.formClasses = JSON.parse(_formClasses));
      }

      localStorage.removeItem('my_class_formdata');
      localStorage.removeItem('my_class_formclasses');
    });
  },
  methods: {
    async init() {
      this.loading = true;
      const user = await this.$http.get('/api/user');
      this.loading = false;
      const { id, name } = user;
      this.user = user;
      const my_class_data = localStorage.getItem('my_class_data');

      this.formTeacher = {
        id,
        name,
      };
      this.formData.teacher_id = id;

      if (this.id && this.name) {
        this.classData = {
          id: this.id,
          name: this.name,
          title: this.title,
          commodities_orders_code: this.code,
          liveroom_course_type: this.course_type,
          hide_course_type: this.hide_course_type,
        };
      } else if (my_class_data) {
        this.classData = JSON.parse(my_class_data);
      }

      if (this.classData) {
        this.checkClass();
      } else {
        this.$router.push('/myClass');
      }
    },
    // 判断线上/线下课数为0的情况
    checkClass() {
      switch (this.classData.hide_course_type) {
        case 'offline_left': this.formData.type = 1, this.hideType = 3;
          break;
        case 'online_left': this.formData.type = 3, this.hideType = 1;
          break;
      }
    },

    // 提交
    onSubmit() {
      this.formData.classes_ids = this.formClasses.map(val => val.id);

      if (this.formData.type == 1) {
        this.$message({
          message: '暂不支持互动直播课',
          type: 'warning',
        });
      } else if (this.formData.type == 3) {
        this.formData.name = this.classData.name || '';

        if (this.formClasses.length) {
          // this.loading = true;

          // this.$http.post('/api/classes/check/student_repeat', {
          //   classes_ids: this.formData.classes_ids,
          // }).then(() => {
          //   this.toMyScreen();
          // }).catch((res) => {
          //   this.dialogTip.content = res.message;
          //   this.dialogTip.show = true;
          //   this.loading = false;
          // }).finally(() => {
          //   this.loading = false;
          // });
          this.toMyScreen();
        } else {
          this.$message({
            message: '至少选择一个班级！',
            type: 'warning',
          });
        }
      } else if (!this.formData.name) {
        this.$message({
          message: '课程名称不能为空！',
          type: 'warning',
        });
      } else {
        this.toMyScreen();
        this.loading = false;
      }
    },

    // 去上课
    toMyScreen() {
      // localStorage.setItem('my_screen_formdata', JSON.stringify(this.formData));
      localStorage.setItem('my_screen_formclasses', JSON.stringify(this.formClasses));

      if (this.id) {
        localStorage.setItem('my_class_data', JSON.stringify(this.classData));
      }

      this.$http.post('/api/liveroom', this.formData).then((res) => {
        const room_id = res.data.id;

        this.$http.post(`/api/liveroom/${room_id}/imkid/course/bind`, {
          commodities_orders_code: this.classData.commodities_orders_code,
          course_id: this.classData.id,
          course_type: this.classData.liveroom_course_type,
          new_course_type: this.classData.new_course_type,
        }).then(() => {
          localStorage.setItem('open_screen', 1);

          this.$router.replace(`/myClass/myRecord?teacher_id=${this.formData.teacher_id}&roomid=${room_id}`);
        }).catch((err) => {
          const msg = err.message;

          this.$http.delete(`/api/liveroom/${room_id}`).then(() => {
            this.$message({
              message: msg,
              type: 'warning',
            });
          });
        }).finally(() => {
          this.loading = false;
        });
      }).catch((err) => {
        this.$message({
          message: err.message,
          type: 'warning',
        });

        this.loading = false;
      });
    },

    // 添加班级
    classAdd() {
      this.formData.classes_ids = this.formClasses.map(val => val.id);
      localStorage.setItem('my_class_formdata', JSON.stringify(this.formData));
      localStorage.setItem('my_class_formclasses', JSON.stringify(this.formClasses));

      this.$router.push(`/myClass/myCreate/myClasses?id=${this.user.id}&name=${this.user.name}`);
    },

    // 移除班级
    removeClasses(index) {
      this.formClasses.splice(index, 1);
    },
  },

  beforeRouteEnter(to, from, next) {
    next(vm => from.name === 'myClasses' && (vm.classesBack = true));
  },
};



// WEBPACK FOOTER //
// ./src/views/MyClass/MyCreate/index.js